import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-badge-up', 'ArrowBadgeUp', [["path",{"d":"M17 11v6l-5 -4l-5 4v-6l5 -4l5 4"}]]);